<template>
	
	<div class="wizard-component upload-input">
		<div class="upload-button" v-for="button in inputFile">
			<input type="file" name="">
			<button class="purple">{{	button.text }}</button>
		</div>
	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			inputFile: [
				{
					text: 'Upload file here'
				}	
			]

		})

	}
</script>


<style></style>